import axiosInstance from '../axios/axios-instance';
import { CreateUserWithdrawalOptionRequest } from './dto/create-user-withdrawal-option-reqeust';
import { GetRewardProgressDto } from 'shared/interfaces/withdrawal/get-reward-progress.dto';
import { GetUserWithdrawalOptionResponseDto } from 'shared/interfaces/withdrawal/get-user-withdrawal-option-response.dto';

export const userWithdrawalOption = {
  /**
   * Creates a user withdrawal option.
   * @param userWithdrawalOption - The user withdrawal option to create.
   * @returns A promise that resolves to the created user withdrawal option.
   */
  async createUserWithdrawalOption(
    userWithdrawalOption: CreateUserWithdrawalOptionRequest,
    verisoulSessionId?: string
  ): Promise<GetUserWithdrawalOptionResponseDto> {
    const response = await axiosInstance.post<GetUserWithdrawalOptionResponseDto>(
      '/user-withdrawal-option',
      userWithdrawalOption,
      {
        headers: {
          'x-session-id': verisoulSessionId,
        },
      }
    );
    return response.data;
  },

  /**
   * Retrieves the user withdrawal options.
   * @returns A promise that resolves to the user withdrawal options.
   */
  async getUserWithdrawalOptions(): Promise<GetUserWithdrawalOptionResponseDto | null> {
    const response = await axiosInstance.get<GetUserWithdrawalOptionResponseDto | null>('/user-withdrawal-option');
    return response.data;
  },

  /**
   * Retrieves user's reward progress.
   * @param pointsEarned - Points earned by user to update the progress.
   * @returns A promise that resolves to the reward progress.
   */
  async getRewardProgress(pointsEarned: number): Promise<GetRewardProgressDto> {
    const response = await axiosInstance.get<GetRewardProgressDto>(
      `/user-withdrawal-option/reward-progress/${pointsEarned}`
    );
    return response.data;
  },
};
